import Vue from 'vue'
import Vuex from 'vuex'

import state from './state'
import getters from './getters'
import actions from './actions'
import mutations from './mutations'

import starMap from './star-map'
import appResource from './app-resource'
import workspace from './workspace'
import template from './template'
import theme from './theme'
import * as T from './module-types'

Vue.use(Vuex)

const modeling = {
    namespaced: false,
    state,
    mutations,
    actions,
    getters,
}

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    modules: {
        modeling,
        [T.APP_RESOURCE]: appResource,
        [T.STAR_MAP]: starMap,
        [T.WORKSPACE]: workspace,
        [T.TEMPLATE]: template,
        [T.THEME]: theme,
    },
})
